module.exports = __webpack_public_path__ + "img/passengers.60ddf03f.svg";